<template>
  <div>
    <!-- <div class="mb-4">
        <declaracion-responsable></declaracion-responsable>
    </div> -->
    <div class="mb-4">
      <condiciones-participar></condiciones-participar>
    </div>
  </div>
</template>

<script>
import CondicionesParticipar from '@/components/eu/CondicionesParticipareu'
import DeclaracionResponsable from '@/components/eu/DeclaracionResponsableEU'

export default {
  components: {
    DeclaracionResponsable,
    CondicionesParticipar
  }
}
</script>